"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedType = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useToolsOptionsSelector_1 = require("./useToolsOptionsSelector");
const useSelectedType = () => (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => (state === null || state === void 0 ? void 0 : state.selectedToolType) || bridge_schema_1.ToolType.None);
exports.useSelectedType = useSelectedType;
